import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import TopBar from "@/components/TopBar";
import Footer from "@/components/Footer";
import WhatsAppFAB from "@/components/WhatsAppFAB";
import BackgroundMedia from "@/components/BackgroundMedia";
import Seo, { composeTitle, truncateForMeta } from "@/components/Seo";
import { Container, SectionLabel, ButtonLux } from "@/components/primitives";
import { useSettings } from "@/context/SettingsContext";
import { api, mediaSrc } from "@/lib/api";

export default function JournalDetail() {
  const { id } = useParams();
  const { settings } = useSettings();
  const [j, setJ] = useState(null);
  useEffect(() => {
    if (id) api.getJournal(id).then(setJ).catch(() => {});
  }, [id]);

  if (!j) return <div className="min-h-screen bg-lux-bg flex items-center justify-center text-lux-muted">Loading…</div>;

  return (
    <div className="min-h-screen bg-lux-bg">
      <Seo
        title={composeTitle(j.seo_title || j.title, settings.seo.default_title, settings.seo.title_suffix)}
        description={truncateForMeta(j.seo_description || j.excerpt || settings.seo.default_description)}
        path={`/journal/${j.id}`}
        imageUrl={j.image_url ? mediaSrc(j.image_url) : undefined}
        type="article"
      />
      <TopBar />
      <div className="relative w-full h-[500px] md:h-[640px] overflow-hidden bg-lux-line">
        <BackgroundMedia videoUrl={j.cover_video_url} imageUrl={j.image_url} testId="journal-detail-media" />
      </div>
      <Container className="pt-10 md:pt-16 pb-24">
        <div className="max-w-[760px]">
          <SectionLabel>{(j.category || "STORIES").toUpperCase()}</SectionLabel>
          <h1 className="font-serif text-lux-ink font-light tracking-tight leading-tight mt-3 text-4xl md:text-6xl">{j.title}</h1>
          <p className="font-serif italic text-lux-sec font-light leading-relaxed mt-6 text-xl md:text-2xl">{j.excerpt}</p>
          <p className="text-lux-sec font-light leading-loose mt-8 text-base md:text-[17px] whitespace-pre-line">{j.body}</p>
          <div className="mt-12 md:mt-14">
            <ButtonLux label="Speak With the Studio" to="/contact" testId="journal-cta" />
          </div>
        </div>
      </Container>
      <Footer />
      <WhatsAppFAB />
    </div>
  );
}
